import React from 'react';
import { Modal, Typography, Button } from 'antd';

const { Title, Paragraph, Text } = Typography;

interface CustomModalProps {
    open: boolean;
    onCancel: () => void;
    children: React.ReactNode;
    onContinue?: () => void;
    loading?: boolean;
    width?: number | string;
    maxWidth?: number | string;
    bodyStyle?: React.CSSProperties;
    title?: React.ReactNode;
    subTitle?: string;
    footer?: React.ReactNode;
    continueButtonText?: string;
    titleText?: string;
}

export const CustomModal: React.FC<CustomModalProps> = ({
    open,
    onCancel,
    children,
    onContinue,
    loading = false,
    width = '90vw',
    maxWidth = '1350px',
    bodyStyle = { maxHeight: '50vh', overflowY: 'scroll' },
    title,
    titleText,
    subTitle,
    footer,
    continueButtonText = 'Continue',
}) => {
    const defaultTitle = (
        <div style={{ textAlign: 'center', padding: '10px 0' }}>
            <Title level={3} className="text-center">
                {titleText}
            </Title>
            <Text type="secondary">{subTitle}</Text>
        </div>
    );

    const defaultFooter =
        onContinue !== undefined ? (
            <div className="text-center my-3">
                <Button
                    id="start-quoting-btn"
                    className="w-100"
                    style={{ maxWidth: 300 }}
                    size="large"
                    type="primary"
                    loading={loading}
                    disabled={loading}
                    onClick={onContinue}
                >
                    {continueButtonText}
                </Button>
            </div>
        ) : null;

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            centered
            title={title ?? defaultTitle}
            width={width}
            style={{ maxWidth }}
            bodyStyle={bodyStyle}
            footer={footer ?? defaultFooter}
        >
            {children}
        </Modal>
    );
};
